import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { App } from './App.tsx';

// 디자인 토큰이 먼저 와야 앱 스타일이 그 위에 얹힙니다.
import './styles/tokens.generated.css';
import './app.css';
import './overlay.css';
import './book.css';
import './room.css';

/**
 * HashRouter 를 쓰는 이유:
 * 웹뷰가 번들을 file:// 로 읽거나 정적 호스팅 서브패스에 올라갈 수 있는데,
 * 그 경우 BrowserRouter 는 새로고침·딥링크에서 404 가 납니다. 해시는 서버 설정이 필요 없습니다.
 */
const root = document.getElementById('root');
if (!root) throw new Error('#root 를 찾지 못했습니다. index.html 을 확인하세요.');

createRoot(root).render(
  <StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </StrictMode>,
);
